module.exports = __webpack_public_path__ + "f2546e124acf24c6250432c23148e98e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/fk.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/fk.svg
// module chunks = 0